<template>
  <Block :title="displayTitle" emoji="🏪">
    <template #actions>
      <router-link to="/admin/analytics/retail" class="text-xs text-primary-dark hover:underline">
        {{ t("view_more") }}
      </router-link>
    </template>
    <BlockList :items="topStores" key-field="storeId">
      <template #default="{ item: store, index }">
        <span>
          {{ index + 1 }}.
          <span :class="{ 'font-bold': store.current }">{{ store.salesChannel }}</span>
          {{ " " }}
          <span class="text-gray-400">(#{{ store.rank }} {{ t("network_label") }})</span>
        </span>
        <span class="font-bold whitespace-nowrap">{{ store.salesCount }}</span>
      </template>
    </BlockList>
  </Block>
</template>

<script>
import { Block, BlockList } from "@estaly/ui";
import { useI18n } from "vue-i18n";

const TOP_COUNT = 5;

export default {
  components: {
    Block,
    BlockList,
  },
  setup() {
    const { t } = useI18n();
    return { t };
  },
  props: {
    storeRanking: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: null,
    },
  },
  computed: {
    displayTitle() {
      return this.title || this.t("title");
    },
    topStores() {
      const myStores = this.storeRanking.filter((s) => s.current);
      if (myStores.length >= TOP_COUNT) {
        return myStores.slice(0, TOP_COUNT);
      }
      const otherSlots = TOP_COUNT - myStores.length;
      const others = this.storeRanking.filter((s) => !s.current).slice(0, otherSlots);
      return [...myStores, ...others].sort((a, b) => a.rank - b.rank);
    },
  },
};
</script>

<i18n src="./TopStoresBlock.i18n.json"></i18n>
